import { Event } from "../../../Global/Base/Events";
import { IPopupMenu, SizeType } from "./IPopupMenu";
/**
 * Pokud je cancelbyclick nastaveno na true, tak se popup zavre pri kliknuti mimo jeho obsah, toto je realizovano tak, ze na body je event click, ktery zavira popup,
 * pokud je klikano do popupu, tak ten si odchytava click a dale ho nepropaguje
 * Toto je potreba udelat i na prvku, ktery popup otvira, cili na udalosti onclick prvku, ktery otevira popup se musi zavolat stopropagation !!!
 */
export class PopupMenu implements IPopupMenu {
    //#region Events
    public onVisibilityChanged: Event<PopupMenu, boolean> = new Event<PopupMenu, boolean>();
    //#endregion Events

    //#region Fields
    protected _contentContainer: HTMLElement = document.createElement("div");
    protected _visible: boolean = false;
    protected _bodyClickListener: EventListener | undefined = undefined;
    protected _popupClickListener: EventListener | undefined = undefined;

    //#endregion Fields

    public get visible(): boolean {
        return this._visible;
    }

    public get element(): HTMLElement {
        return this._contentContainer;
    }

    //#region Constructors
    /**
     * Kontruktor popupmenu, POZOR - aby korektne fungovalo, je potřeba na události, která otvírá popup nastavit callingEvent.stopPropagation() !!!
     * Je nastaveno v Construktoru
     *
     * Kdyz je cancelbyclick nastaveno na true, tak se popup zavre pri kliknuti mimo jeho obsah, toto je realizovano tak, ze na body je event click, ktery zavira popup,
     * pokud je klikano do popupu, tak ten si odchytava click a dale ho nepropaguje
     * Toto je potreba udelat i na prvku, ktery popup otvira, cili na udalosti onclick prvku, ktery otevira popup nastavit callingEvent.stopPropagation()!!!
     *
     * @param contentElement element, ktery se bude v popup menu zobrazovat
     * @param cancelByClick pokud je true, tak se okno automaticky zavre, pokud se klikne mimo okno, defaultne true
     * @param width sirka komponenty jako string (aby se daly zadat i %)
     * @param height vyska komponenty jako string (aby se daly zadat i %)
     * @param top odsazeni od vrchniho okraje stranky jako string (aby se daly zadat i %)
     * @param left odsazeni od leveho okraje stranky jako string (aby se daly zadat i %)
     * @param bottom odsazeni od dolniho okraje stranky
     * @param right odsazeni od praveho okraje stranky
     */
    constructor(contentElement?: HTMLElement, protected cancelByClick: boolean = true, width: string = "50%", height: string = "50%", top: string = "25%", left: string = "25%", bottom: string = "25%", right: string = "25%") {
        if (contentElement == null)
            return;

        this._initialize(contentElement);

        this.setSize(width, height);
        this.setIndent(top, left, bottom, right);
        this._setListeners();
    }
    //#endregion Constructors

    //#region Methods

    /**
     * Inicializace komponenty
     * @param innerElement element, ktery se bude v popup menu zobrazovat
     */
    protected _initialize(innerElement?: HTMLElement): void {
        if (innerElement) {
            innerElement.style.width = "100%";
            innerElement.style.height = "100%";
            this._contentContainer.appendChild(innerElement);
        }
        this._contentContainer.classList.add("PopupMenu");
        document.body.appendChild(this._contentContainer);
    }

    /**
     * Nastaveni listeneru
     */
    protected _setListeners(): void {
        if (this.cancelByClick) {
            // všechny popupy zavíráme pokud došlo ke kliknutí někam do okna (i pokud došlo k zastavení této události - událost "clickCancelled")
            window.addEventListener("click", this._bodyClickListener = (_e) => {
                if (this.visible)
                    this.setVisibility(false);
            });
            window.addEventListener("clickCancelled", this._bodyClickListener);
        }

        this._contentContainer.addEventListener("click", this._popupClickListener = (e) => e.stopPropagation());
    }

    /**
     * Nastaveni odsazeni
     * @param top odsazeni od vrchinoho okraje stranky
     * @param left odsazeni od leveho okraje stranky
     * @param bottom odsazeni od dolniho okraje stranky
     * @param right odsazeni od praveho okraje stranky
     */
    public setIndent(top: string | null = null, left: string | null = null, bottom: string | null = null, right: string | null = null): void {
        if (top)
            this._contentContainer.style.top = top;

        if (left)
            this._contentContainer.style.left = left;

        if (bottom)
            this._contentContainer.style.bottom = bottom;

        if (right)
            this._contentContainer.style.right = right;
    }

    /**
     * Nastaveni rozmeru
     * @param width sirka popup menu
     * @param height vyska popup menu
     */
    public setSize(width: SizeType | string, height: SizeType | string): void {
        const w = typeof width === "number" ? width + "px" : width;
        const h = typeof height === "number" ? height + "px" : height;

        this._contentContainer.style.width = w;
        this._contentContainer.style.height = h;
    }

    /**
     * Nastaveni viditelnosti komponenty
     * @param visible boolean
     */
    public setVisibility(visible: boolean): void {
        this._visible = visible;
        this._contentContainer.style.display = visible ? "" : "none";
        this.onVisibilityChanged.trigger(this, this.visible);
    }

    /**
     * Kontrola, zda se menu vleze pod zadane souradnice
     */
    public checkIfFitsVerticaly(): boolean {
        const windowH = window.innerHeight;
        const offsetTop = this._contentContainer.getBoundingClientRect().top;
        return windowH - (this._contentContainer.clientHeight + offsetTop) > 0;
    }

    public arangePopupToEditableControl(popUpElemenet: HTMLElement, targetControlElement: HTMLElement, hasFocus: boolean, gridRect: ClientRect | null = null, width: SizeType | null = null, height: SizeType | null = null): void {
        if (popUpElemenet != undefined && this) {
            const rect = targetControlElement.getBoundingClientRect();

            const w = typeof width === "number" ? width : popUpElemenet.offsetWidth;
            const h = typeof height === "number" ? height : popUpElemenet.offsetHeight;

            this.setSize(width ?? w, height ?? h); // width i height by nemeli chodit dovnitr nenastaveny

            if (gridRect && hasFocus) { //jsem na datagridu a ma focus
                const upper = rect.bottom - gridRect.top < -1;
                const downer = gridRect.bottom - rect.top < -1;

                if (this.visible) { //je viditelny a komponenta leze mimo viditelnou cast datagridu
                    if (upper || downer) { //nahoru nebo dolu
                        this.setVisibility(false);
                        return; //pokud ho skryju tak koncim vykonani funcke - pomerne dulezita vec!!!
                    }
                }

                if (this.visible != true) { //je neviditelny a komponenta leze do viditelne casti datagridu a ma focus
                    if (!upper && !downer)
                        this.setVisibility(true);
                }
            }
            let errorTop;
            let errorLeft;
            let errorBottom;
            let errorRight;
            if (window.innerHeight - rect.bottom < h) { //vyska okna - spodni okraj editovatelneho pole je mensi nez velikost validacni hlasky
                errorTop = rect.top - h + "px";
                errorBottom = rect.top + "px";
            } else {
                errorTop = rect.bottom + "px";
                errorBottom = rect.bottom + h + "px";
            }

            if (window.innerWidth - rect.left < w) { //sirka okna
                errorLeft = rect.right - w + "px";
                errorRight = rect.right + "px";
            } else {
                errorLeft = rect.left + "px";
                errorRight = rect.left - w + "px";
            }

            this.setIndent(errorTop, errorLeft, errorBottom, errorRight);
        }
    }

    /**
     * Zavreni PopupMenu
     */
    public close(): void {
        this.setVisibility(false);
        this.dispose();
    }

    /**
     * Destruktor
     */
    public dispose(): void {
        this._contentContainer?.parentElement?.removeChild(this._contentContainer);

        if (this._bodyClickListener)
            document.body.removeEventListener("click", this._bodyClickListener);
        if (this._popupClickListener)
            document.body.removeEventListener("click", this._popupClickListener);
        this.onVisibilityChanged.removeAll();
    }

    //#endregion Methods
}
